import { render, staticRenderFns } from "./TrackingDeviceActivities.vue?vue&type=template&id=4870fb36"
import script from "./TrackingDeviceActivities.vue?vue&type=script&lang=js"
export * from "./TrackingDeviceActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports